import React, { useState, useEffect } from 'react';
import MyInvestment from '@/components/Profile/MyInvestment';
import { getDetailsMember } from '../Loyalty/function';
import { Helmet } from 'react-helmet-async';
import { InvestmentPackage } from '@/api/type';

const MyInvestmentTab: React.FC = () => {
  const [investments, setInvestments] = useState<InvestmentPackage[]>([]);
  const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')!) : null;
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate API call
    const fetchInvestments = async () => {
      setLoading(true);
      try {
        getDetailsMember(user!.id).then((res) => {
          if (res) {
            const { data: packages } = res;
            setInvestments(packages || []);
          } else {
            setInvestments([]);
          }
        });
      } catch (error) {
        console.error('Error fetching investments:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchInvestments();
  }, []);

  return <>
    <Helmet>
      <title>Đầu tư của tôi | BEQ Reward</title>
    </Helmet>
    <MyInvestment investments={investments} loading={loading} allowRedirect={true} />
  </>;
};

export default MyInvestmentTab;